import styled from 'styled-components';

import { MOBILE } from '../../../../theme/tokens';
import { Button } from '../../../../components/Button';

/**
 * The byline's own row styles.
 *
 * They used to be borrowed from `SeoLists.styles`, which stopped being possible
 * when those rows became sortable list items: an author is ONE record, not a
 * list, and its rows are a two-column form rather than entries with a position.
 * The link list under it is a list, but a short one whose order is the order it
 * was typed in, so it keeps the plain rows and gains only the same secondary add
 * button the SEO lists use.
 */

export const RowsWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

/** One row of the form: fields grow, the remove button trails. */
export const Row = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

export const PairRow = styled.div`
  display: flex;
  gap: 8px;
  flex: 1;
  min-width: 0;

  ${MOBILE} {
    flex-direction: column;
  }
`;

export const AddButton = styled(Button)`
  align-self: flex-start;
  height: 36px;
  padding: 0 14px;
  font-size: 14px;
  gap: 6px;
`;
